import { applicationStore } from '../../store/applicationStore';
import { setHttpClientInterceptors } from '../http/httpClient';
import { gameService } from '../gameService';
import { menuSectionStore } from '../../store/menuSectionStore';
import { userSettingsStore } from '../../store/userSettingsStore';
import { betReplayService } from '../betReplayService';
import {gameStore} from "../../store/gameStore";

export const PostMessage = {
  PgReload: 'pgReload',
  PgLogout: 'pgLogout',
  GameReady: 'gameReady',
  PgGameLoaded: 'pgGameLoaded',
  PgLoginCheck: 'pgLoginCheck',
  PgGetAuthInfo: 'pgGetAuthInfo',
  PgRedirectHome: 'pgRedirectHome',
  PgRedirectLogin: 'pgRedirectLogin',
  TournamentFinished: 'tournamentFinished',
  OnOpenerIconClick: 'onOpenerIconClick',
  ErrorReceived: 'errorReceived',
};

export const PostMessageListenerMessages = {
  UpdateBalance: 'updateBalance',
  StopAutoSpins: 'stopAutospins',
  AuthInfoUpdate: 'authInfoUpdate',
  OpenerIcons: 'openerIcons',
  TournamentUpdate: 'tournamentUpdate',
  WatchAgain: 'watchAgain',
  FullscreenChange: 'fullscreenChange',
  OpenPayTable: 'openPaytable',
  IsBrazilGLI: 'isBrazilGLI',
};

class IframeService {
  sendParentMessage(message, transfer, targetOrigin = '*') {
    window.parent.postMessage(message, targetOrigin, transfer);
  }

  sendTopMessage(message, transfer, targetOrigin = '*') {
    window.top.postMessage(message, targetOrigin, transfer);
  }

  openTab(tab) {
    this.sendTopMessage({ action: 'openSlider', tab });
  }

  openDeposit() {
    this.openTab('deposit');
  }

  openLogin() {
    this.openTab('login');
  }

  reloadFrame() {
    this.sendParentMessage(PostMessage.PgReload);
  }

  logout() {
    this.sendParentMessage(PostMessage.PgLogout);
  }

  sendTournamentFinished() {
    this.sendParentMessage({ name: PostMessage.TournamentFinished });
  }

  sendLoadedState() {
    this.sendParentMessage(PostMessage.PgGameLoaded);
  }

  sendGetAuthInfo() {
    this.sendParentMessage(PostMessage.PgGetAuthInfo);
  }

  sendPgLogin() {
    this.sendParentMessage(PostMessage.PgLoginCheck);
  }

  redirectLogin() {
    this.sendParentMessage(PostMessage.PgRedirectLogin);
  }

  redirectHome() {
    this.sendParentMessage(PostMessage.PgRedirectHome);
  }

  sendGameIsReady() {
    this.sendParentMessage({ name: PostMessage.GameReady });
  }

  sendErrorReceived(payload) {
    this.sendParentMessage({ name: PostMessage.ErrorReceived, payload });
  }

  redirect(type = false) {
    type ? this.redirectHome() : this.redirectLogin();
  }

  /**
   * @deprecated please use redirect
   */
  redirection(type) {
    this.redirect(type);
  }

  isInIframe() {
    try {
      return window.self !== window.top;
    } catch (e) {
      return true;
    }
  }

  setPostMessageListener(messageParams) {
    if (!this.isInIframe()) {
      applicationStore.setIsAuthDataReceived(true);
    } else {
      window.addEventListener('message', (message) => {
        if (message.data && message.data.name === PostMessageListenerMessages.AuthInfoUpdate) {
          const { accessToken, isAuthenticated, isOperatorHandlesErrors } = message.data;
          applicationStore.setIsAuthenticated(isAuthenticated);
          applicationStore.setAccessToken(accessToken);
          applicationStore.setIsAuthDataReceived(true);
          applicationStore.setIsOperatorHandlesErrors(isOperatorHandlesErrors);
          setHttpClientInterceptors();
        }
        if (message.data && message.data.name === PostMessageListenerMessages.OpenerIcons) {
          applicationStore.setIconsInfo(message.data.icons);
        }
        if (message.data && message.data.name === PostMessageListenerMessages.TournamentUpdate) {
          gameService.getTournamentUpdate();
        }
        if (message.data && message.data.name === PostMessageListenerMessages.FullscreenChange) {
          userSettingsStore.setIsFullScreen(message.data.payload.isFullscreen);
        }
        if (message.data && message.data.name === PostMessageListenerMessages.WatchAgain) {
          betReplayService.getBetReplayData();
          gameStore.setIsReplayWatchAgain(true);
        }
        if (message.data && message.data.name === PostMessageListenerMessages.OpenPayTable) {
          menuSectionStore.setIsShowMenuPopup(true);
          applicationStore.setIsShowPayTableMode(true);
        }
        if (message.data && message.data.name === PostMessageListenerMessages.IsBrazilGLI) {
          applicationStore.setIsShowLicenseMode(true);
        }

        if (messageParams && messageParams.length) {
          messageParams.forEach(({ name, callback }) => {
            if (message.data && message.data.name === name) {
              callback(message.data);
            }
          });
        }
      });
    }
  }
}

const iframeService = new IframeService();

export { iframeService, IframeService as BaseIframeService };
